module.exports = __webpack_public_path__ + "img/combo_course_188_bottom.119aec94.png";